import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Slider as MUISlider, makeStyles } from '@material-ui/core';
import { ThemeContext } from 'styled-components';

const prettoStyles = makeStyles({
  root: ({ colors, space }) => ({
    color: colors.secondary,
    height: space[2],
  }),
  thumb: ({ colors, space }) => ({
    height: space[6],
    width: space[6],
    backgroundColor: colors.white,
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  }),
  active: () => {},
  mark: ({ colors, space }) => ({
    height: space[1],
    backgroundColor: colors.secondary,

    '&.MuiSlider-markActive': {
      height: space[1],
      backgroundColor: colors.white,
    },
  }),
  track: ({ space }) => ({
    height: space[2],
    borderRadius: 4,
  }),
  rail: ({ space }) => ({
    height: space[2],
    borderRadius: 4,
  }),
});

const defaultStyle = makeStyles({
  root: ({ colors, space }) => ({
    color: colors.primary,
    height: space[1],
  }),
  thumb: ({ colors, space }) => ({
    height: space[3],
    width: space[3],
    backgroundColor: colors.primary,
  }),
  active: () => {},
  mark: ({ colors }) => ({
    width: '5px',
    height: '5px',
    borderRadius: '100%',
    transform: 'translateY(-0.5px)',
    backgroundColor: colors.greyscale.grey1,

    '&.MuiSlider-markActive': {
      backgroundColor: colors.greyscale.grey4,
    },
  }),
  track: ({ colors }) => ({
    height: '3px',
    backgroundColor: colors.greyscale.grey1,
  }),
  rail: ({ colors }) => ({
    height: '3px',
    backgroundColor: colors.greyscale.grey3,
  }),
});

const Slider = ({ defaultValue, step, valueLabelDisplay, variant, ...props }) => {
  const theme = useContext(ThemeContext);
  const prettoClasses = prettoStyles(theme);
  const defaultClasses = defaultStyle(theme);

  switch (variant) {
    case 'pretto':
      return (
        <MUISlider
          classes={prettoClasses}
          defaultValue={defaultValue}
          valueLabelDisplay={valueLabelDisplay}
          step={step}
          {...props}
        />
      );
    default:
      return (
        <MUISlider
          classes={defaultClasses}
          defaultValue={defaultValue}
          valueLabelDisplay={valueLabelDisplay}
          step={step}
          {...props}
        />
      );
  }
};

Slider.defaultProps = {
  variant: 'default',
  defaultValue: 0,
  valueLabelDisplay: 'auto',
  step: 1,
};

Slider.propTypes = {
  variant: PropTypes.oneOf(['default', 'pretto']),
  defaultValue: PropTypes.number,
  valueLabelDisplay: PropTypes.oneOf(['on', 'auto', 'off']),
  step: PropTypes.number,
};

export default Slider;
